import { FC } from "react";

import FullPageErrorMessage from "../components/elements/FullPageErrorMessage";

const Error404: FC = () => {
  return <FullPageErrorMessage messageKey="404" />;
};

export default Error404;
